module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.prefixCls
  }, [_vm._l((_vm.data), function(item) {
    return _c('Tree-node', {
      key: item,
      attrs: {
        "data": item,
        "visible": "",
        "multiple": _vm.multiple,
        "show-checkbox": _vm.showCheckbox
      }
    })
  }), _vm._v(" "), (!_vm.data.length) ? _c('div', {
    class: [_vm.prefixCls + '-empty']
  }, [_vm._v(_vm._s(_vm.localeEmptyText))]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39cfa66b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/iview/src/components/tree/tree.vue
// module id = 621
// module chunks = 1